import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { login_header_logo } from "../../constant";
import ConfirmEmail from "./AccountStep/ConfirmEmail";
import CreateProfile from "./AccountStep/CreateProfile";
import CreateProfilesStep4 from "./AccountStep/CreateProfilesStep4";
import BecomeMember from "./AccountStep/BecomeMember";

const steps = [
	"Select campaign settings",
	"Create an ad group",
	"Create an ad",
	"Create an ad",
];
const CreateAccount = () => {
	const [activeStep, setActiveStep] = React.useState(0);
	const [skipped, setSkipped] = React.useState(new Set());

	const isStepOptional = (step) => {
		return step === 1;
	};

	const isStepSkipped = (step) => {
		return skipped.has(step);
	};

	const handleNext = () => {
		let newSkipped = skipped;
		if (isStepSkipped(activeStep)) {
			newSkipped = new Set(newSkipped.values());
			newSkipped.delete(activeStep);
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSkipped(newSkipped);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleSkip = () => {
		if (!isStepOptional(activeStep)) {
			// You probably want to guard against something like this,
			// it should never occur unless someone's actively trying to break something.
			throw new Error("You can't skip a step that isn't optional.");
		}

		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSkipped((prevSkipped) => {
			const newSkipped = new Set(prevSkipped.values());
			newSkipped.add(activeStep);
			return newSkipped;
		});
	};

	const handleReset = () => {
		setActiveStep(0);
	};
	const stopsubmit = (event) => {
		event.preventDefault();
	};
	return (
		<>
			{/* header logo starts here */}
			<header className="login-header">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="header-logo-wrapper">
								<figure>
									<img src={login_header_logo} alt="" />
								</figure>
							</div>
						</div>
					</div>
				</div>
			</header>
			{/* header logo ends here */}
			{/* login starts here */}
			<section className="login-sec Create-account">
				<div className="container">
					<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-10">
							{/* <div className="login-card-wrapper">
								<div className="login-heading-wrapper">
									<h3>Create Your Account</h3>
								</div>
								<div className="login-form-wrapper mt-5">
									<form action="">
										<div className="form-group row">
											<div className="col-lg-6">
												<input
													type="text"
													className="form-control"
													placeholder="First name"
												/>
											</div>
											<div className="col-lg-6">
												<input
													type="text"
													className="form-control"
													placeholder="Last name"
												/>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-6">
												<input
													type="text"
													className="form-control"
													placeholder="D.O.B"
												/>
											</div>
											<div className="col-lg-6">
												<select name="" className="form-control" id="">
													<option value="Gender (Optional)" selected>
														Gender (Optional)
													</option>
													<option value="Gender (Optional)">
														Gender (Optional)
													</option>
													<option value="Gender (Optional)">
														Gender (Optional)
													</option>
												</select>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-6">
												<input
													type="Email"
													className="form-control"
													placeholder="D.O.B"
												/>
												<p>
													<>You will confirm this in next step</>
												</p>
											</div>
											<div className="col-lg-6">
												<button className="btn">Submit</button>
											</div>
										</div>
										<div className="form-group"></div>
									</form>
								</div>
							</div>
							<ConfirmEmail />
							<CreateProfile /> */}

							<Box sx={{ width: "100%" }}>
								<Stepper activeStep={activeStep}>
									{steps.map((label, index) => {
										const stepProps: { completed?: boolean } = {};
										const labelProps: {
											optional?: React.ReactNode,
										} = {};
										if (isStepOptional(index)) {
											labelProps.optional = (
												<Typography variant="caption">Optional</Typography>
											);
										}
										if (isStepSkipped(index)) {
											stepProps.completed = false;
										}
										return (
											<Step key={label} {...stepProps}>
												{/* <StepLabel {...labelProps}>{label}</StepLabel> */}
											</Step>
										);
									})}
								</Stepper>
								{activeStep === steps.length ? (
									<React.Fragment>
										<BecomeMember />
									</React.Fragment>
								) : (
									<React.Fragment>
										{/* <Typography sx={{ mt: 2, mb: 1 }}>
											Step {activeStep + 1}
										</Typography> */}
										{activeStep + 1 == 1 ? (
											<div className="login-card-wrapper">
												<div className="login-heading-wrapper">
													<h3>Create Your Account</h3>
												</div>
												<div className="login-form-wrapper mt-5">
													<form onSubmit={stopsubmit} action="">
														<div className="form-group row">
															<div className="col-lg-6">
																<input
																	type="text"
																	className="form-control"
																	placeholder="First name"
																/>
															</div>
															<div className="col-lg-6">
																<input
																	type="text"
																	className="form-control"
																	placeholder="Last name"
																/>
															</div>
														</div>
														<div className="form-group row">
															<div className="col-lg-6">
																<input
																	type="text"
																	className="form-control"
																	placeholder="D.O.B"
																/>
															</div>
															<div className="col-lg-6">
																<select name="" className="form-control" id="">
																	<option value="Gender (Optional)" selected>
																		Gender (Optional)
																	</option>
																	<option value="Gender (Optional)">
																		Gender (Optional)
																	</option>
																	<option value="Gender (Optional)">
																		Gender (Optional)
																	</option>
																</select>
															</div>
														</div>
														<div className="form-group row">
															<div className="col-lg-6">
																<input
																	type="Email"
																	className="form-control"
																	placeholder="D.O.B"
																/>
																<p>
																	<>You will confirm this in next step</>
																</p>
															</div>
															<div className="col-lg-6">
																<button onClick={handleNext} className="btn">
																	Submit
																</button>
															</div>
														</div>
														<div className="form-group"></div>
													</form>
												</div>
											</div>
										) : activeStep + 1 == 2 ? (
											<ConfirmEmail NextStep={handleNext} />
										) : activeStep + 1 == 3 ? (
											<CreateProfile NextStep={handleNext} />
										) : (
											<CreateProfilesStep4 NextStep={handleNext} />
										)}
										{/* <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
											<Button
												color="inherit"
												disabled={activeStep === 0}
												onClick={handleBack}
												sx={{ mr: 1 }}
											>
												Back
											</Button>

											<Box sx={{ flex: "1 1 auto" }} />
											{isStepOptional(activeStep) && (
												<>
													<Button
														color="inherit"
														onClick={handleSkip}
														sx={{ mr: 1 }}
													>
														Skip
													</Button>
												</>
											)}
											<Button onClick={handleNext}>
												{activeStep === steps.length - 1 ? "Finish" : "Next"}
											</Button>
										</Box> */}
									</React.Fragment>
								)}
							</Box>
						</div>
						<div className="col-lg-1"></div>
					</div>
				</div>
			</section>
			{/* login ends here */}
		</>
	);
};

export default CreateAccount;
